var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drop-wave"},[_c('div',{staticClass:"drop"}),_c('div',{staticClass:"wave"})])
}]

export { render, staticRenderFns }